import CONSTANTS from '@/constants'
import { Pass, Plan, Subscription, Invoice } from '../../types'

interface SubscriptionsState {
  currentSubscriptions?: Array<Subscription>
  currentInvoices?: Array<Invoice>
  passTypes?: Array<Pass>
  manageablePassStates: Array<string>
  addTermPricing?: object
  availablePlans?: Array<Plan>
  planDetails: Array<{ name: string; checked: string }>
  currentPlanComparison?: {
    next?: {
      price: string
      due_today: string
      credit_fwd: string
      discount: string
      renewal_total: string
      period_end: string
    }
  }
  newPlanCodes: Array<string>
  premiumPlanCode: string
  paymentInfo: {
    last4_of_cc: string
    account_credit: string
    payment_method: string
  }
  cancellationFields: object
}

const state: SubscriptionsState = {
  currentSubscriptions: [],
  currentInvoices: [],
  passTypes: [],
  manageablePassStates: CONSTANTS.SUBSCRIPTIONS.MANAGEABLE_STATES,
  addTermPricing: {},
  availablePlans: [],
  planDetails: [
    {
      name: 'Access entire course library',
      checked: 'all',
    },
    {
      name: 'Github and Azure projects',
      checked: 'all',
    },
    {
      name: 'Cyber Security Labs',
      checked: CONSTANTS.PLANS.PREMIUM,
    },
    {
      name: 'Live Online Bootcamps',
      checked: CONSTANTS.PLANS.PREMIUM,
    },
    {
      name: 'Networking Workbooks',
      checked: CONSTANTS.PLANS.PREMIUM,
    },
  ],
  currentPlanComparison: {},
  newPlanCodes: [
    CONSTANTS.PLANS.PREMIUM,
    CONSTANTS.PLANS.ANNUAL,
    CONSTANTS.PLANS.MONTHLY,
    ...CONSTANTS.PLANS.BUSINESS.map(p => p),
  ],
  premiumPlanCode: CONSTANTS.PLANS.PREMIUM,
  paymentInfo: {
    last4_of_cc: '',
    account_credit: '$0',
    payment_method: '',
  },
  cancellationFields: {},
}

export { SubscriptionsState, state }
